/**
 * CMS feature flag key for the ImageLabel browse surfaces.
 *
 * Gates the /rooms directory and the project photography walls at
 * /projects/spaces and /projects/styles — one flag releases the set, so the
 * key lives in one place. The sibling image_label_search_profile gates the
 * same browse on a professional's profile.
 */
export const IMAGE_LABEL_DIRECTORY_FEATURE_KEY = 'image_label_search_directory';
